import fetchAPI from "./fetchAPI"

export async function createSwishOrder(amount, productId, token) {
  let { origin, pathname } = window.location

  const { createSwishOrder } = await fetchAPI(
    `mutation($amount: Int!, $productId: Int!, $sourceUrl: String!, $token: String!) {
        createSwishOrder(amount: $amount, productId: $productId, sourceUrl: $sourceUrl, token: $token) {
          result
        }
      }`,
    {
      variables: { amount, productId, sourceUrl: origin + pathname, token }
    }
  )

  return createSwishOrder
}

export async function completeSwishOrder(paymentId, token) {
  const { completeSwishOrder } = await fetchAPI(
    `mutation($paymentId: String!, $token: String!) {
        completeSwishOrder(paymentId: $paymentId, token: $token)
      }`,
    {
      variables: { paymentId, token }
    }
  )

  return completeSwishOrder
}
